import { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';

import { useLocation } from 'react-router-dom';

type Props = {
  children: ReactNode;
};
export type MenuTypes =
  | 'competition-hierarchy'
  | 'proposals'
  | 'settings'
  | 'matching'
  | 'coverage'
  | 'report';
type ActiveMenuContext = [MenuTypes, Dispatch<SetStateAction<MenuTypes>>];

export const ActiveMenuContext = createContext<ActiveMenuContext | undefined>(undefined);

export const ActiveMenuProvider = ({ children }: Props): JSX.Element => {
  const { pathname } = useLocation();
  const [, currentActiveMenu] = pathname.split('/');
  const [activeMenu, setActiveMenu] = useState<MenuTypes>(
    (currentActiveMenu as MenuTypes) || 'competition-hierarchy',
  );
  const contextValue: ActiveMenuContext = useMemo(
    () => [activeMenu, setActiveMenu],
    [activeMenu, setActiveMenu],
  );

  return <ActiveMenuContext.Provider value={contextValue}>{children}</ActiveMenuContext.Provider>;
};
